// extracted by mini-css-extract-plugin
module.exports = {"richText":"rich-text-layout-module--richText--2burw","smallerMargins":"rich-text-layout-module--smallerMargins--ivXTh"};